/* dropdown-group.js
 * Hydrates .beanies-dropdown[data-dropdowngroup] with full product list
 * via Storefront GraphQL API. Bypasses 50-product collection limit.
 *
 * Config injected from theme:
 *   window.SleefsDropdownGroup = { token, apiVersion, shopDomain }
 */
(function () {
  'use strict';

  var CONFIG = window.SleefsDropdownGroup || {};
  var TOKEN = CONFIG.token;
  var API_VERSION = CONFIG.apiVersion || '2024-10';
  var SHOP = CONFIG.shopDomain || window.location.host;
  var EXCLUDE_TAGS = ['oddsox'];
  var PAGE_SIZE = 100;
  var MAX_PAGES = 20;
  var CACHE_TTL_MS = 10 * 60 * 1000;

  if (!TOKEN) {
    console.warn('[dropdown-group] missing Storefront token; skipping hydration');
    return;
  }

  var ENDPOINT = 'https://' + SHOP + '/api/' + API_VERSION + '/graphql.json';

  var QUERY = [
    'query DropdownGroup($q: String!, $first: Int!, $after: String) {',
    '  products(first: $first, after: $after, query: $q) {',
    '    pageInfo { hasNextPage endCursor }',
    '    edges {',
    '      node {',
    '        id',
    '        handle',
    '        title',
    '        tags',
    '        featuredImage { url(transform: {maxWidth: 80, maxHeight: 80}) altText }',
    '      }',
    '    }',
    '  }',
    '}'
  ].join('\n');

  function cacheKey(group) { return 'sleefs:dropdowngroup:' + group; }

  function readCache(group) {
    try {
      var raw = sessionStorage.getItem(cacheKey(group));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || Date.now() - parsed.ts > CACHE_TTL_MS) return null;
      return parsed.products;
    } catch (e) { return null; }
  }

  function writeCache(group, products) {
    try {
      sessionStorage.setItem(cacheKey(group), JSON.stringify({ ts: Date.now(), products: products }));
    } catch (e) { /* quota / disabled */ }
  }

  function gidToNumericId(gid) {
    if (!gid) return '';
    var parts = String(gid).split('/');
    return parts[parts.length - 1];
  }

  function gqlFetch(variables) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Shopify-Storefront-Access-Token': TOKEN
      },
      body: JSON.stringify({ query: QUERY, variables: variables })
    }).then(function (r) {
      if (!r.ok) throw new Error('Storefront API ' + r.status);
      return r.json();
    });
  }

  function fetchAllForGroup(group) {
    var q = 'tag:"dropdown-group:' + group + '"';
    console.log('[dropdown-group] Query:', q);
    console.log('[dropdown-group] Products found:', out);
    var out = [];
    var cursor = null;
    var page = 0;

    function next() {
      page++;
      if (page > MAX_PAGES) return Promise.resolve(out);
      return gqlFetch({ q: q, first: PAGE_SIZE, after: cursor }).then(function (resp) {
        if (resp.errors) {
          console.error('[dropdown-group] GraphQL errors', resp.errors);
          return out;
        }
        var data = resp.data && resp.data.products;
        if (!data) return out;
        data.edges.forEach(function (edge) {
          var n = edge.node;
          out.push({
            id: gidToNumericId(n.id),
            handle: n.handle,
            title: n.title,
            tags: n.tags || [],
            image: n.featuredImage ? n.featuredImage.url : '',
            alt: (n.featuredImage && n.featuredImage.altText) || n.title
          });
        });
        if (data.pageInfo.hasNextPage) {
          cursor = data.pageInfo.endCursor;
          return next();
        }
        return out;
      });
    }

    return next();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderList(listEl, products, currentId) {
    products.forEach(function(p){
  console.log(
    p.title,
    'id=', p.id,
    'current=', currentId,
    'excluded=', EXCLUDE_TAGS.some(function(tag){
      return p.tags.indexOf(tag) !== -1;
    }),
    'tags=', p.tags
  );
});
    var html = products.filter(function (p) {
      if (String(p.id) === String(currentId)) return false;
      for (var i = 0; i < EXCLUDE_TAGS.length; i++) {
        if (p.tags.indexOf(EXCLUDE_TAGS[i]) !== -1) return false;
      }
      return true;
    }).map(function (p) {
      var url = '/products/' + p.handle;
      var img = p.image || '';
      return '<div class="beanie-option" data-url="' + escapeHtml(url) + '"'
        + ' data-image="' + escapeHtml(img) + '"'
        + ' data-title="' + escapeHtml(p.title) + '">'
        + (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.alt) + '">' : '')
        + '<span>' + escapeHtml(p.title) + '</span>'
        + '</div>';
    }).join('');
    listEl.innerHTML = html;
    listEl.setAttribute('data-state', 'hydrated');
    attachDelegation(listEl);
    console.log(
  '[dropdown-group] products returned:',
  products.length,
  products
);
  }

  function attachDelegation(listEl) {
    if (listEl.__sleefsDelegated) return;
    listEl.__sleefsDelegated = true;
    var selectedImg = document.getElementById('selected-img');
    var selectedTitle = document.getElementById('selected-title');
    listEl.addEventListener('click', function (e) {
      var opt = e.target.closest && e.target.closest('.beanie-option');
      if (!opt) return;
      var url = opt.getAttribute('data-url');
      var img = opt.getAttribute('data-image');
      var title = opt.getAttribute('data-title');
      if (selectedImg && img) selectedImg.src = img;
      if (selectedTitle && title) selectedTitle.textContent = title;
      listEl.classList.remove('visible');
      if (url) window.location.href = url;
    });
  }

  var inflight = {};

  function hydrate(rootEl) {
    var group = rootEl.getAttribute('data-dropdowngroup');
    var currentId = rootEl.getAttribute('data-current-product-id');
    var listEl = rootEl.querySelector('#beanies-list, .beanies-list');
    if (!group || !listEl) return;

    var cached = readCache(group);
    if (cached) {
      renderList(listEl, cached, currentId);
      return;
    }

    listEl.setAttribute('data-state', 'loading');

    if (!inflight[group]) {
      inflight[group] = fetchAllForGroup(group).then(function (products) {
        writeCache(group, products);
        return products;
      }).catch(function (err) {
        console.error('[dropdown-group] fetch failed; keeping SSR fallback', err);
        listEl.setAttribute('data-state', 'ssr');
        return null;
      });
    }

    inflight[group].then(function (products) {
      if (products) renderList(listEl, products, currentId);
    });
  }

  function init() {
    var roots = document.querySelectorAll('.beanies-dropdown[data-dropdowngroup]');
    for (var i = 0; i < roots.length; i++) {
      var el = roots[i];
      if (!el.getAttribute('data-dropdowngroup')) continue;
      hydrate(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
